import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskReveal, Reveal } from "./Reveal";
import { MANIFESTO, PORTRAIT_IMG } from "./data";

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="manifesto" ref={ref} className="relative overflow-hidden bg-ink-900 py-28 md:py-44">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="mb-20 max-w-3xl">
          <Reveal>
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">/ The Ethos</span>
          </Reveal>
          <h2 className="mt-5 font-oswald text-5xl font-700 uppercase leading-[0.85] tracking-tighter text-white md:text-7xl">
            <MaskReveal lines={["More Than", "A Playlist"]} />
          </h2>
        </div>

        <div className="grid gap-16 lg:grid-cols-[0.85fr_1.15fr] lg:gap-24">
          {/* Portrait with parallax */}
          <div className="relative order-2 h-[460px] overflow-hidden bg-ink-950 lg:order-1 lg:h-[720px]">
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_35%,rgba(212,175,55,0.12),transparent_60%)]" />
            <motion.div style={{ y: imgY }} className="absolute inset-x-0 -top-[12%] -bottom-[12%]">
              <img src={PORTRAIT_IMG} alt="DJ Jazzy the Great portrait" className="h-full w-full object-cover object-top" />
            </motion.div>
            <div className="absolute inset-0 bg-gradient-to-t from-ink-900/80 to-transparent" />
            <div className="absolute left-6 top-6 border border-gold/40 px-4 py-2">
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Behind the Decks</span>
            </div>
          </div>

          {/* Numbered chapters */}
          <div className="order-1 flex flex-col gap-14 lg:order-2 lg:pt-6">
            {MANIFESTO.map((m, i) => (
              <Reveal key={m.n} delay={i * 0.08} className="relative">
                <div className="pointer-events-none absolute -top-8 -left-2 select-none font-oswald text-8xl font-700 leading-none text-stroke md:-top-12 md:text-[10rem]">
                  {m.n}
                </div>
                <div className="relative pt-10 pl-4 md:pt-16 md:pl-16">
                  <h3 className="font-oswald text-3xl font-600 uppercase tracking-tight text-white md:text-4xl">
                    {m.title}
                  </h3>
                  <p className="mt-4 max-w-md text-sm leading-relaxed text-zinc-400 md:text-base">
                    {m.copy}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
